import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '%100 dijital PDF ve mobil erişim'
}, {
  icon: ZapIcon,
  label: 'Anında indirme'
}, {
  icon: BotIcon,
  label: 'ChatGPT, Claude, Gemini ve DeepSeek ile kullanım'
}, {
  icon: SmartphoneIcon,
  label: 'Mobil ve kurum içi bilgisayarlar için pratik'
}];
export const stats = [{
  value: '500+',
  label: 'Memnun profesyonel'
}, {
  value: '6+4',
  label: 'Cilt ve bonus'
}, {
  value: '%99',
  label: 'Başarı oranı'
}, {
  value: '4,9/5',
  label: '⭐ Genel değerlendirme'
}];
